import { render, staticRenderFns } from "./docdetail.vue?vue&type=template&id=069d24b4&scoped=true"
import script from "./docdetail.vue?vue&type=script&lang=js"
export * from "./docdetail.vue?vue&type=script&lang=js"
import style0 from "./docdetail.vue?vue&type=style&index=0&id=069d24b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069d24b4",
  null
  
)

export default component.exports